import { createSlice } from "@reduxjs/toolkit";
import { fetchFeatureFlags, updateFeatureFlag } from "./thunkActions";

interface InitialState {
  flags: IFeatureFlag[];
  isLoading: boolean;
  error: string | null;
  savingKey: string | null;
  requestId: string | null;
}

const initialState: InitialState = {
  flags: [],
  isLoading: false,
  error: null,
  savingKey: null,
  requestId: null,
};

export const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureFlags.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.requestId = action.meta.requestId;
      })
      .addCase(fetchFeatureFlags.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.flags = action.payload;
        state.isLoading = false;
        state.requestId = null;
      })
      .addCase(fetchFeatureFlags.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.isLoading = false;
        state.requestId = null;
        if (!action.meta.aborted) {
          state.error = action.payload ?? "Could not load feature flags.";
        }
      })
      .addCase(updateFeatureFlag.pending, (state, action) => {
        state.savingKey = action.meta.arg.key;
      })
      .addCase(updateFeatureFlag.fulfilled, (state, action) => {
        const index = state.flags.findIndex((flag) => flag.key === action.meta.arg.key);
        if (index !== -1) state.flags[index] = action.payload;
        state.savingKey = null;
      })
      .addCase(updateFeatureFlag.rejected, (state) => {
        state.savingKey = null;
      });
  },
});

export default featureFlagsSlice.reducer;
export * from "./thunkActions";
